import script from "./ApplicationApplicantDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationApplicantDetails.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__